import React from 'react'
import { Box, Button, Element } from 'react-bulma-components'
import { JobTitle } from '../../api/job-titles'
import { useUpdateMutation } from '../../queries/job-titles'
import ConfirmationModal from '../confirmation-modal/confirmation-modal'
import { useModal } from '../modal'

interface JobTitleDangerZoneProps {
  jobTitle: JobTitle
}

/**
 * Composant pour gérer les actions dangereuses sur un job title
 * comme la désactivation/réactivation
 */
const JobTitleDangerZone: React.FC<JobTitleDangerZoneProps> = ({ jobTitle }) => {
  const updateMutation = useUpdateMutation()
  const { isDisplayed: isConfirmationDisplayed, setIsDisplayed: setIsConfirmationDisplayed } =
    useModal()

  const isJobTitleInactive = jobTitle.isInactive

  const handleToggleStatus = async () => {
    await updateMutation.mutateAsync({
      id: jobTitle._id.toString(),
      isInactive: !isJobTitleInactive,
    })
    setIsConfirmationDisplayed(false)
  }

  return (
    <>
      <Box mt={5} pt={2}>
        <Element className="is-flex is-justify-content-space-between is-align-items-center" mt={2}>
          <Element>
            <Element textWeight="bold">
              {isJobTitleInactive ? 'Réactiver ce métier' : 'Désactiver ce métier'}
            </Element>
            <Element textSize={7} textColor="grey">
              {isJobTitleInactive
                ? 'Une fois réactivé, le métier sera à nouveau disponible pour les missions et les demandes'
                : 'Une fois désactivé, vous pourrez le réactiver plus tard'}
            </Element>
          </Element>
          <Button
            color={isJobTitleInactive ? 'success' : 'danger'}
            onClick={() => setIsConfirmationDisplayed(true)}
            data-test="disable-job-title-button"
            size="small"
          >
            {isJobTitleInactive ? 'Réactiver le métier' : 'Désactiver le métier'}
          </Button>
        </Element>
      </Box>

      <ConfirmationModal
        show={isConfirmationDisplayed}
        onConfirm={handleToggleStatus}
        onCancel={() => setIsConfirmationDisplayed(false)}
        title={isJobTitleInactive ? 'Réactiver le métier' : 'Désactiver le métier'}
        confirmButtonLabel={isJobTitleInactive ? 'Réactiver' : 'Désactiver'}
        confirmButtonProps={{
          color: isJobTitleInactive ? 'success' : 'danger',
          disabled: false,
        }}
      >
        <>
          {isJobTitleInactive ? (
            <>
              Êtes-vous sûr de vouloir réactiver ce métier ?
              <br />
              Le métier sera à nouveau disponible pour les missions et les demandes.
            </>
          ) : (
            <>
              Êtes-vous sûr de vouloir désactiver ce métier ?
              <br />
              Les missions utilisant ce métier ne seront pas impactées et conserveront leur
              historique.
              <br />
              <br />
              <Element textWeight="bold">
                Le métier ne sera plus visible dans les filtres et ne pourra plus être sélectionné
                pour la création de nouvelles missions et de nouvelles demandes.
              </Element>
            </>
          )}
        </>
      </ConfirmationModal>
    </>
  )
}

export default JobTitleDangerZone
